export const compareTags = (tag1, tag2) => {
  return tag1.id > tag2.id ? 1 : -1
}
